import qs from "qs";
import apiError from './apierror';


export default function(reqInfo){
  var reqName=reqInfo.reqName;
  var reqData=reqInfo.reqData;
  var reqConfig=reqInfo.reqConfig;
  var reqAttrs = reqConfig.attrs || {}
  window.eeoDynamicHost = window.EEOENV.hosts.dynamic
  return axios({
    url: '//'+(window.eeoDynamicHost || '')+reqConfig.url,
    method: reqConfig.method || 'post',
    responseType: 'text',
    ...reqAttrs,
    data: qs.stringify(reqConfig.data(reqData)),
    transformResponse: [
      function(res) {
        var jsonObj = false;
        try {
          jsonObj = JSON.parse(res)
        }
        catch (res) {
          alert(res.error_info.error);
        }
        if (jsonObj) {
          return reqConfig.transformResponse(jsonObj);
        } else {
          return false
        }
      }
    ]
  })
};
